// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../client';
import { getLang } from '../../../i18n/l10n';
import { GRBannerImgByLang } from '../assets/img/banners';
import GRBannerCountdownContainer from '../containers/GRBannerCountdownContainer';

const Wrapper = styled.div`
  position: relative;
  transition: filter 150ms ease-in-out;

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          filter: brightness(110%);
        }
      `
    : undefined}

  ${({ onClick }) => {
    if (onClick) {
      return css`
        cursor: pointer;
      `;
    }
  }}
`;

const Background = styled.img`
  border-radius: 0.6em;
  width: 100%;
  padding: 0;
  margin: 0;
`;
const StyledGrBannerCountdownContainer = styled(GRBannerCountdownContainer)`
  position: absolute;
  left: 1em;
  top: 1.3em;
  font-size: 0.6em;
  line-height: 1.1em;
  z-index: 1;

  ${!Target.__MOBILE__
    ? css`
        font-size: 0.9em;
      `
    : null};
`;

type GRBannerProps = {
  className?: string;
  onClick?: () => void;
  showCountdown?: boolean;
};

const GRBanner = ({ className, onClick, showCountdown = false }: GRBannerProps) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <Background src={GRBannerImgByLang[getLang()]} />
      {showCountdown ? <StyledGrBannerCountdownContainer /> : null}
    </Wrapper>
  );
};

export default GRBanner;
